import {User} from "./user";

export class EmployeeSchedule {
    id: string;
    user: User;
    startDate: string;
    endDate: string;
    description: string;
}